<template>
    <div>
        <div v-for="(proposals,name) in itemsNoZeroCommission">
            <div class="row">
                <div class="col-md-12">
                    <div class="panel panel-defaul">
                        <div class="panel-body" style="overflow-x: auto;">
                            <b>{{ profiles[profile] }}: {{ name }}</b>
                            <table id="tabela" class="table b-table table-sm">
                                <thead class="thead-dark">
                                    <tr>
                                        <th class="text-center" rowspan="2" v-if="isAlternateLayout">Administradora</th>
                                        <th class="text-center" rowspan="2" v-if="isAlternateLayout">Contrato</th>
                                        <th class="text-center" rowspan="2" v-if="isAlternateLayout">Data Venda</th>
                                        <th class="text-center" rowspan="2">Cliente</th>
                                        <th class="text-center" rowspan="2" v-if="!isAlternateLayout">Data Venda</th>
                                        <th class="text-center" rowspan="2" v-if="!isAlternateLayout">Contrato</th>
                                        <th class="text-center" rowspan="2" v-if="!isCondensedReport">Grupo</th>
                                        <th class="text-center" rowspan="2" v-if="!isCondensedReport">Cota</th>
                                        <th class="text-center" rowspan="2">Carta</th>
                                        <th class="text-center" v-if="!isCondensedReport" :colspan="getInstallmentCommission(proposals[0]).length">
                                            Comissões</th>
                                        <th class="text-center" rowspan="2" v-if="!isAlternateLayout">Estorno</th>
                                        <th class="text-center" rowspan="2" v-if="!isCondensedReport">Prêmio p/ volume</th>
                                        <th class="text-center" colspan="3" v-if="!isCondensedReport">Totais</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" v-if="!isCondensedReport" v-for="installment in getInstallmentCommission(proposals[0])">{{ installment.quote }}ª Parcela</th>
                                        <th class="text-center" v-if="!isCondensedReport">Comissão</th>
                                        <th class="text-center" v-if="!isCondensedReport">Prêmio por Volume</th>
                                        <th class="text-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="proposal in proposals" :key="proposal.id" v-bind:on="calcToResume(profile, name, proposal, proposals)">
                                        <td v-if="isAlternateLayout">{{ getAdministrator(proposal.administrator_id).name }}</td>
                                        <td v-if="isAlternateLayout">{{ proposal.physical_proposal }}</td>
                                        <td v-if="isAlternateLayout">{{ proposal.sale_at | moment('DD/MM/YYYY') }}</td>
                                        <td>{{ proposal.client.name }}</td>
                                        <td v-if="!isAlternateLayout">{{ proposal.sale_at | moment('DD/MM/YYYY') }}</td>
                                        <td v-if="!isAlternateLayout">{{ proposal.physical_proposal }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">{{ proposal.group_name }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">{{ proposal.quota }}</td>
                                        <td class="text-center">R${{ proposal.value | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport" v-for="installment in getInstallmentCommission(proposal)">R${{ calcInstallment(proposal, installment) | price }}</td>
                                        <td class="text-center" v-if="!isAlternateLayout">R${{ calcChargeback(proposal) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcVolume(proposal, proposals) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcContemplate(proposal) + calcGroup(proposal) + calcDeployment(proposal, proposals) + reduce(proposal) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcVolume(proposal, proposals) | price }}</td>
                                        <td class="text-center">R${{ calcContemplate(proposal) + calcGroup(proposal) + calcDeployment(proposal, proposals) + reduce(proposal) + calcVolume(proposal, proposals) | price }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td :colspan="(isCondensedReport ? 2 : 4) - (isAlternateLayout ? 1 : 0)">Total</td>
                                        <td class="text-center"> ({{ proposals.length }} cotas)</td>
                                        <td colspan="2" v-if="isAlternateLayout"></td>
                                        <td class="text-center">R${{ sum(proposals, 'value') | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport" v-for="installment in getInstallmentCommission(proposals[0])">R${{ calcInstallment(proposals, installment, true) | price }}</td>
                                        <td class="text-center" v-if="!isAlternateLayout">R${{ calcChargeback(proposals, true) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcVolume(proposals, proposals, true) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcContemplate(proposals, true) + calcGroup(proposals, true) + calcDeployment(proposals, proposals, true) + reduce(proposals, true) | price }}</td>
                                        <td class="text-center" v-if="!isCondensedReport">R${{ calcVolume(proposals, proposals, true) | price }}</td>
                                        <td class="text-center">R${{ calcContemplate(proposals, true) + calcGroup(proposals, true) + calcDeployment(proposals, proposals, true) + reduce(proposals, true) + calcVolume(proposals, proposals, true) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false && getExtraRewardAmount(proposals, 1) > 0">
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">{{ getExtraRewardName(proposals, 1) }}</td>
                                        <td class="text-center">R${{ getExtraRewardAmount(proposals, 1) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false && getExtraRewardAmount(proposals, 2) > 0">
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">{{ getExtraRewardName(proposals, 2) }}</td>
                                        <td class="text-center">R${{ getExtraRewardAmount(proposals, 2) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false && getExtraRewardAmount(proposals, 3) > 0">
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">{{ getExtraRewardName(proposals, 3) }}</td>
                                        <td class="text-center">R${{ getExtraRewardAmount(proposals, 3) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false && getPastChargebackAmount(proposals) > 0">
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">{{ getPastChargebackName(proposals) }}</td>
                                        <td class="text-center">R${{ getPastChargebackAmount(proposals) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false">
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">Comissão Total Final</td>
                                        <td class="text-center">R${{ calcContemplate(proposals, true) + calcGroup(proposals, true) + calcDeployment(proposals, proposals, true) + reduce(proposals, true) + calcVolume(proposals, proposals, true) + getExtraRewardAmount(proposals) - getPastChargebackAmount(proposals) | price }}</td>
                                    </tr>
                                    <tr v-if="displayCommissionsPerAdministrator == false && getCommissionRuleText(proposals)">
                                        <td v-bind:colspan="isCondensedReport ? 6 : getInstallmentCommission(proposals[0]).length + 11" v-html="getCommissionRuleText(proposals)"></td>
                                    </tr>
                                    <tr>
                                        <td v-bind:colspan="isCondensedReport ? 5 : getInstallmentCommission(proposals[0]).length + 10">Ticket Médio</td>
                                        <td class="text-center">R${{ sum(proposals, 'value') / proposals.length | price }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-6 text-center">
                    __________________________________________________________________<br />
                    {{ name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                premioVolume: [],
                profileId: 0,
                profiles: {
                    'admin': 'Administrador',
                    'manager': 'Gerente',
                    'supervisor': 'Supervisor',
                    'salesman': 'Vendedor',
                    'after_sale': 'Pós Venda',
                },
                reversal: 0,
                typeProfilesId: {
                    'admin': 1,
                    'manager': 2,
                    'supervisor': 3,
                    'salesman': 4,
                    'after_sale': 5,
                }
            };
        },
        methods: {
            getExtraRewardAmount(proposals, which) {
                return this.$parent.getExtraRewardAmount(
                    this.profile == 'supervisor' ? proposals[0].supervisor_id : proposals[0].salesman_id,
                    which
                );
            },
            getExtraRewardName(proposals, which) {
                return this.$parent.getExtraRewardName(
                    this.profile == 'supervisor' ? proposals[0].supervisor_id : proposals[0].salesman_id,
                    which
                ) || 'Premiação Extra';
            },
            getCommissionRuleText(proposals) {
                return this.$parent.getCommissionRuleText(this.profile == 'supervisor' ? proposals[0].supervisor_id : proposals[0].salesman_id);
            },
            getPastChargebackName(proposals) {
                return this.$parent.getPastChargebackName(this.profile == 'supervisor' ? proposals[0].supervisor_id : proposals[0].salesman_id) || 'Estorno Retroativo';
            },
            getPastChargebackAmount(proposals) {
                return this.$parent.getPastChargebackAmount(this.profile == 'supervisor' ? proposals[0].supervisor_id : proposals[0].salesman_id);
            },
            calcToResume(profile, name, proposal, proposals) {
                    const valueContemplate = this.calcContemplate(proposal)
                    const valueGroup = this.calcGroup(proposal)
                    const valueDeployment = this.calcDeployment(proposal, proposals)
                    const valueReduce = this.reduce(proposal);
                    const firstMainValue = valueContemplate + valueGroup + valueDeployment + valueReduce;

                    const valueVolume = this.calcVolume(proposal, proposals);
                    const valueChargeback = this.calcChargeback(proposal);
                    const valueChargebackProposals = this.calcChargebackProposals(proposal);

                    this.updateResume(
                        profile,
                        name,
                        proposal.value,
                        firstMainValue,
                        valueVolume,
                        1,
                        proposal.salesman_id,
                        proposal.supervisor_id,
                        proposal.administrator_id,
                        valueChargeback,
                        valueChargebackProposals,
                        proposal.id
                    );
            },
            getInstallmentCommission(_proposal) {
                var self=this;
                var commission = this.commissions.find(commission => commission.profile_id == self.getProfileId(_proposal))
                if (commission && commission.installments)
                    return commission.installments;

                return [];
            },
            calcChargeback(_item, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcChargeback(_proposal);
                    });

                    return sum;
                }

                var installments = _item.installments;
                var installmentsCommission = self.getInstallmentCommission(_item);
                if (installments.length > 0) {
                    var commission = 0;
                    var reversal;
                    installments.forEach(function(_installment) {
                        if (_installment.reversal_at !== null) {
                            reversal = installmentsCommission.find(reversal => reversal.quote === _installment.order);
                            if (reversal !== undefined) {
                                commission += parseFloat(_item.value) * (reversal.commission_reversal / 100);
                            }
                        }
                    });
                    return commission;
                }
                return 0;
            },
            calcChargebackProposals(_item, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcChargebackProposals(_proposal);
                    });

                    return sum;
                }

                var installments = _item.installments;
                var installmentsCommission = self.getInstallmentCommission(_item);
                if (installments.length > 0) {
                    var total = 0;
                    var reversal;
                    installments.forEach(function(_installment) {
                        if (_installment.reversal_at !== null) {
                            reversal = installmentsCommission.find(reversal => reversal.quote === _installment.order);
                            if (reversal !== undefined) {
                                total += parseFloat(_item.value);
                            }
                        }
                    });
                    return total;
                }
                return 0;
            },
            calcContemplate(_item, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcContemplate(_proposal);
                    });

                    return sum;
                }

                var profileId = self.getProfileId(_item);

                var commission = self.commissions.find(commission => parseInt(commission.profile_id) === parseInt(profileId));

                if (commission !== undefined && commission.default !== undefined && commission.default !== null) {
                    if (_item.contemplate_at !== null) {
                        return parseFloat(_item.value) * (commission.default.comission_contemplation / 100);
                    }
                }
                return 0;
            },
            calcDeployment(_item, _items, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcDeployment(_proposal, _items);
                    });

                    return sum;
                }

                var profileId = self.getProfileId(_item);

                var commission = self.commissions.find(commission => parseInt(commission.profile_id) === parseInt(profileId));
                if (commission !== undefined && commission.default !== undefined && commission.default !== null) {
                    if (commission.default.min_quotes <= _items.length && _items.length <= commission.default.max_quotes && _item.deployment_at !== null) {
                        return commission.default.deployment_commision;
                    }
                }

                return 0;
            },
            calcGroup(_item, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcGroup(_proposal);
                    });

                    return sum;
                }

                var profileId = self.getProfileId(_item);

                var commission = self.commissions.find(commission => parseInt(commission.profile_id) === parseInt(profileId));

                if (commission !== undefined && commission.default !== undefined && commission.default !== null && commission.default.groups !== undefined) {
                    var group = commission.default.groups.find(commission => commission.group_id === _item.group_id);

                    if (group !== undefined) {
                        if (group.group_commission_type == 'F') {
                            return group.comission;
                        } else {
                            return parseFloat(_item.value) * (group.comission / 100);
                        }
                    }
                }

                return 0;
            },
            calcInstallment(_item, _installment, _calcTotal = false) {
                var self = this;

                if (_calcTotal) {
                    var sum = 0;

                    _item.forEach(function (_proposal) {
                        sum += self.calcInstallment(_proposal, _installment);
                    });

                    return sum;
                }

                var installments = _item.installments;

                if (installments.length > 0 && _installment.quote > 0) {
                    var installment = installments.find(installment => installment.order == _installment.quote);
                    if(installment){
                        if (installment.pay_at !== null || installment.reversal_at !== null || self.date_by == 'due_at-all') {
                            var commission = parseFloat(_item.value) * (_installment.commission / 100);
                            if(installment.reversal_at != null){
                                commission = commission - parseFloat(_item.value) * (_installment.commission_reversal / 100);
                            }

                            return commission;
                        }

                    }
                }

                return 0;
            },
            calcVolume(_item, _proposals, _calcTotal = false) {
                var self = this;
                var sum = 0

                if (_calcTotal) {
                    var subSum = parseFloat(0);

                    _item.forEach(function (_proposal) {
                        subSum += self.calcVolume(_proposal, _proposals);
                    });

                    return subSum;
                }

                var profileId = self.getProfileId(_item);

                var commission = self.commissions.find(commission => parseInt(commission.profile_id) === parseInt(profileId));

                if (commission && commission.campaign && _proposals != null && _item.installments.length > 0) {
                    var proposalsVolume = _item.volume_proposals;
                    var campaign = commission.campaign;
                    if (campaign.initial_date <= _item.sale_at && _item.sale_at <= campaign.final_date) {
                        var quotas = campaign.quotas;
                        var amounts = campaign.amounts;
                        var installments = _item.installments;

                        quotas.forEach(function (_quota) {
                            var installment = installments.find(installment => installment.order == _quota.vol_quota);

                            if (installment && (installment.pay_at != null || self.date_by == 'due_at-all')) {
                                console.log("Installment paied!");
                                var volumeCount = self.getProposalsVolumeCount(proposalsVolume, installment.order);
                                console.log("Volume quotes: " + volumeCount);
                                if (_quota.min_quota <= volumeCount && volumeCount <= _quota.max_quota) {
                                    console.log("Between quotes");
                                    if (_quota.type_quota == 'F') {
                                        sum += _quota.value_quota;
                                    } else {
                                        sum += parseFloat(_item.value) * (_quota.value_quota / 100);
                                    }
                                }
                            }
                            console.log(sum);
                        });

                        amounts.forEach(function (_amount) {
                            var installment = installments.find(installment => installment.order == _amount.vol_quota);
                            if (installment && (installment.pay_at != null || self.date_by == 'due_at-all')) {
                                var volumeAmount = self.getProposalsVolumeAmount(_proposals, installment.order);
                                if (_amount.min_amount <= volumeAmount && volumeAmount <= _amount.max_amount) {
                                    if (_amount.type_quota == 'F') {
                                        sum += _amount.value_quota;
                                    } else {
                                        sum += parseFloat(_item.value) * (_amount.value_quota / 100);
                                    }
                                }
                            }
                        });

                        var closingMonth = campaign.closing_months ? campaign.closing_months.find(closingMonth => closingMonth.initial_quota <= _proposals.length && _proposals.length <= closingMonth.final_quota) : null;

                        if (closingMonth && closingMonth.commissions) {
                            var closingMonthCommission = closingMonth.commissions ? closingMonth.commissions.find(closingMonthCommission => closingMonthCommission.min_quota <= _proposals.length && _proposals.length <= closingMonthCommission.max_quota) : null;
                            console.log(closingMonthCommission)
                            if (closingMonthCommission != undefined) {
                                var installment = installments.find(installment => installment.order == closingMonthCommission.quote);
                                if (installment && (installment.pay_at != null || self.date_by == 'due_at-all')) {
                                    sum += parseFloat(_item.value) * (closingMonthCommission.commission / 100);
                                }
                            }
                        }
                    }
                }

                var name = _item[self.profile] || '';
                return parseFloat(sum) + (parseFloat(self.premioVolume[name]));
            },
            getProposalsVolumeCount(proposalsVolume, installmentOrder) {
                var self = this;
                if (self.date_by != 'pay_at' && self.date_by != 'due_at' && self.date_by != 'due_at-all') {
                    return proposalsVolume.length;
                }
                var count = 0;
                for (var i = 0; i < proposalsVolume.length; i++) {
                    var installments = proposalsVolume[i].installments;
                    var paidInstallmentSameOrder = installments.find(installment => installment.order == installmentOrder && (installment.pay_at != null || self.date_by == 'due_at-all'));
                    if (paidInstallmentSameOrder) {
                        count++;
                    }
                }

                return count;
            },
            getProposalsVolumeAmount(_proposals, installmentOrder) {
                var self = this;
                if (self.date_by != 'pay_at' && self.date_by != 'due_at' && self.date_by != 'due_at-all') {
                    return _proposals.reduce((acc, _proposal) => acc + parseFloat(_proposal.value), 0);
                }
                var sum = 0;
                for (var i = 0; i < _proposals.length; i++) {
                    var proposal = _proposals[i];
                    var installments = proposal.installments;
                    console.log("Here");
                    var paidInstallmentSameOrder = installments.find(installment => installment.order == installmentOrder && (installment.pay_at != null || self.date_by == 'due_at-all'));
                    if (paidInstallmentSameOrder) {
                        console.log(proposal, parseFloat(proposal.value));
                        sum += parseFloat(proposal.value);
                    }
                }

                return sum;
            },
            getProfileId(_proposal) {
                var self = this;

                switch (self.profile) {
                    case 'manager':
                        return _proposal.profile_manager_id;
                        break;

                    case 'supervisor':
                        return _proposal.profile_supervisor_id;
                        break;

                    case 'after_sale':
                        return _proposal.profile_after_sale_id;
                        break;

                    default:
                        return _proposal.profile_salesman_id;
                        break;

                }
            },
            processaPremioPorVolumeTotal(_items, _commissions) {
                var self = this;

                var campaign = false;
                if (_commissions.length > 0 && _commissions[0].campaign !== undefined && _commissions[0].campaign !== null) {
                    campaign = _commissions[0].campaign;
                }

                Object.entries(_items).forEach(function(_item) {
                    var name = _item[0]
                    var proposals = _item[1]

                    self.premioVolume[name] = 0;

                    var countPremiosValidos = 0;
                    proposals.forEach(function(_proposal) {
                        if (campaign !== false && campaign.initial_date !== undefined && campaign.final_date !== undefined) {
                            var initialDate = new Date(campaign.initial_date);
                            var finalDate = new Date(campaign.final_date);
                            var saleDate = new Date(_proposal.sale_at);
                            if (initialDate <= saleDate && saleDate <= finalDate) {
                                countPremiosValidos++;
                            }
                        }
                    })

                    if (campaign !== false && countPremiosValidos >= campaign.min_quantity && campaign.commission) {
                        self.premioVolume[name] = campaign.commission;
                    }
                });
            },
            reduce(_item, _calcTotal = false) {
                var sum = 0;
                var self = this;

                if (_calcTotal) {
                    var subSum = 0;

                    _item.forEach(function (_proposal) {
                        subSum += self.reduce(_proposal);
                    });

                    return subSum;
                }

                var installments = self.getInstallmentCommission(_item);

                installments.forEach(function (_installment) {
                    sum += self.calcInstallment(_item, _installment)
                });

                return sum;
            },
            sum(_proposals, _field) {
                var value = 0;
                _proposals.forEach(function (_proposal) {
                    value += parseFloat(eval("_proposal." + _field));
                });

                return value;
            },
            updateResume (
                _profile,
                _name,
                _value,
                _commission,
                _volume,
                _proposalsAmount,
                _salesmanId,
                _supervisorId,
                _administratorId,
                _chargeback,
                _chargebackProposals,
                _proposalId
            ) {
                var volume = 0;
                if (isNaN(_volume)) {
                    volume = 0;
                } else {
                    volume = _volume;
                }
                const store = {
                    profile: _profile,
                    name: _name,
                    valorTotal: _value,
                    commissionTotal: _commission,
                    volumeTotal: volume,
                    proposalsAmount: _proposalsAmount,
                    salesmanId: _salesmanId,
                    supervisorId: _supervisorId,
                    administratorId: _administratorId,
                    chargeback: _chargeback,
                    chargebackProposals: _chargebackProposals,
                    proposalId: _proposalId
                }
                this.$store.dispatch('reports/resumeAnalyticalCommissionProfile', store)
            },
            getAdministrator(administrator_id) {
                let administrators = this.$store.state.administrators.itens;
                for (let i=0; administrators.length; i++) {
                    if (administrators[i].id == administrator_id) {
                        return administrators[i];
                    }
                }
            }
        },
        beforeMount() {
            var self = this;
            self.processaPremioPorVolumeTotal(self.items, self.commissions);
        },
        mounted() {
            var self = this;

            switch (self.profile) {
                case 'admin':
                    self.profileId = 1;
                    break;

                case 'manager':
                    self.profileId = 2;
                    break;

                case 'supervisor':
                    self.profileId = 3;
                    break;

                case 'salesman':
                    self.profileId = 4;
                    break;

                case 'after_sale':
                    self.profileId = 5;
                    break;
            }
        },
        props: ['commissions', 'items', 'profile', 'totals', 'date_by'],
        computed: {
            isCondensedReport: function () {
                return Boolean(this.$store.state.configurations.model.condensed_analytical_commission_by_profile_report);
            },
            displayCommissionsPerAdministrator: function () {
                return Boolean(this.$store.state.configurations.model.display_commissions_totals_only_on_analytical_commission_by_profile_report) == false;
            },
            isAlternateLayout: function () {
                return Boolean(this.$store.state.configurations.model.analytical_commission_by_profile_report_alternate_layout);
            },
            itemsNoZeroCommission: function () {
                var self = this;
                var _itemsNoZeroCommission = {};

                for (var name in self.items) {
                    var proposals = self.items[name];
                    var _proposalsNoZeroCommission = [];
                    var totalCommission = 0;
                    for (var i=0; i<proposals.length; i++) {
                        var proposal = proposals[i];
                        var commission = self.calcContemplate(proposal) +
                            self.calcGroup(proposal) +
                            self.calcDeployment(proposal, proposals) +
                            self.reduce(proposal) +
                            self.calcVolume(proposal, proposals);
                        console.log(commission);
                        if (commission == 0) {
                            continue;
                        }
                        _proposalsNoZeroCommission.push(proposal);
                    }
                    if (_proposalsNoZeroCommission.length == 0) {
                        continue;
                    }
                    _itemsNoZeroCommission[name] = _proposalsNoZeroCommission;
                }

                return _itemsNoZeroCommission;
            }
        }
    };
</script>
